import React, { useState } from 'react';

const Nav = () => {
	return (
		<>
			<nav className="nav">
				<a
					target="_blank"
					rel="noreferrer"
					href="https://github.com/KentenRoth"
				>
					GitHub
				</a>
				<a
					target="_blank"
					rel="noreferrer"
					href="https://www.linkedin.com/in/kentenroth/"
				>
					LinkedIn
				</a>
			</nav>
		</>
	);
};

export default Nav;
